import {useStompClient, useSubscription} from "react-stomp-hooks";
import React, {useEffect, useState} from "react";
import {StompHeaders} from "@stomp/stompjs";
import {useKeycloak} from "@react-keycloak/web";
import {Button, message, Tooltip} from "antd";
import {ParticipantStatus} from "../../../enums/ParticipantStatus";
import {faPhone} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default function CallLeaveButton({username, participantConnectingStatus, handleLogout}: {
    username: string,
    participantConnectingStatus: ParticipantStatus,
    handleLogout: any
}) {

    return (<SubscribingComponent username={username}
                                  participantConnectingStatus={participantConnectingStatus}
                                  handleLogout={handleLogout}/>)

}

const SubscribingComponent: React.FC<{
    username: string,
    participantConnectingStatus: string,
    handleLogout: any
}> = ({username, participantConnectingStatus, handleLogout}) => {
    const [messageApi, contextHolder] = message.useMessage();
    const [participantConnected, setParticipantConnected] = useState<boolean>(false);
    const {keycloak} = useKeycloak();
    let stompHeaders: StompHeaders = {
        "accessToken": keycloak.token ? keycloak.token : "",
        "username": username
    }

    const stompClient = useStompClient();


    useEffect(() => {
        if (participantConnectingStatus == ParticipantStatus.PARTICIPANT_CONNECTED) {
            setParticipantConnected(true);
        } else {
            setParticipantConnected(false);
        }
    }, [participantConnectingStatus]);
    const onCallLeave = (e: any) => {
        handleLogout(e)

        if (participantConnectingStatus == ParticipantStatus.PARTICIPANT_CONNECTED) {


            console.log(stompClient)
            /*stompClient?.publish({
                destination: `/video/app/check-image-upload-status`,
                body: JSON.stringify({
                    "imageType": imageType,
                    "uploadStatus": UploadStatus.UPLOADING,
                    "username": username
                })
            });*/


        } else {
            messageApi.open({
                key: "Video",
                type: 'warning',
                content: `Participant not connected`,
                duration: 3,
            });
        }
    }


    useSubscription("/user/topic/check-image-upload-status", (message) => {
        let res: any = JSON.parse(message.body);
        stompClient?.publish({
            destination: `/video/app/acknowledge`,
            body: message.headers.messageId
        });
        console.log(`check-image-upload-status Acknowledgment sent for message: ${message.headers.messageId}`);
        if (res.content, res.errorMessage) {
            messageApi.open({
                key: "Video",
                type: 'error',
                content: `Video Can not be Recorded`,
                duration: 3,
            });
        } else {
            /*if (imageType == res.imageType) {
                if (res.uploadStatus == UploadStatus.UPLOADED) {
                    messageApi.open({
                        key: imageType,
                        type: 'success',
                        content: `${imageType} Successfully Uploaded`,
                        duration: 3,
                    });
                } else {
                    messageApi.open({
                        key: imageType,
                        type: 'error',
                        content: `${imageType} Can not be Uploaded`,
                        duration: 3,
                    });
                }

            }*/
        }
    }, stompHeaders);
    return <>
        {contextHolder}
        <Tooltip title="End Call">
            <Button className='end-call-btn' type="primary"
                    style={{backgroundColor: participantConnected ? '#de0000' : '#cecccc'}} shape="circle"
                    icon={<FontAwesomeIcon icon={faPhone}/>} onClick={onCallLeave} size={"large"}/></Tooltip>

    </>
}
